// extracted by mini-css-extract-plugin
export var arrow = "_kd-1";
export var content = "_kd-0";
export var highlighted = "_kd-2";